import { combineReducers } from 'redux';

import reportReducer from './reportReducer';
import indicatorReducer from './indicatorReducer';
import chartReducer from './chartReducer';
import filtersReducer from './filtersReducer';
import dashboardReducer from './dashboardReducer';
import funderReducer from './funderReducer';
import beneficiariesReducer from './beneficiariesReducer';
import profileReducer from './profileReducer';
import totalsReducer from './totalsReducer';
import detailsReducer from './detailsReducer';
import drawerReducer from './drawerReducer';

const rootReducer = combineReducers({
  reports: reportReducer,
  indicators: indicatorReducer,
  chart: chartReducer,
  filters: filtersReducer,
  dashboard: dashboardReducer,
  funder: funderReducer,
  beneficiaries: beneficiariesReducer,
  profile: profileReducer,
  totals: totalsReducer,
  details: detailsReducer,
  drawer: drawerReducer,
});

export default rootReducer;
